import { useState, useEffect } from "react"
import { PageTitle } from "@/components/custom/PageTitle"
import { DataTable } from "./UsersTable"
import { columns } from "./columns"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState } from "@/redux"
import { UserTableRow } from "@/types/users"
import { mappedRole } from "@/constants/users/userRole"
import { UserStatus } from "@/constants/users/userStatus"
import { getPageButtonText } from "@/helpers/button"

export const Users = () => {
  const navigate = useNavigate()
  const [allUsers, setAllUsers] = useState<UserTableRow[]>([])
  const { users, invitedUsers, userData } = useSelector((state: RootState) => state.user)

  useEffect(() => {
    const isMe = (userId: string, userEmail: string): boolean => {
      if (userData?.id === userId && userData.email === userEmail) {
        return true
      }
      return false
    }

    const usersInTable: UserTableRow[] = []
    if (invitedUsers.length) {
      invitedUsers.forEach(u => {
        usersInTable.push({
          id: u.id,
          name: '',
          email: u.email,
          role: mappedRole[u.role],
          status: UserStatus.INVITED,
          isMyself: false
        })
      })
    }
    if (users.length) {
      users.forEach(u => {
        usersInTable.push({
          id: u.id,
          name: `${u.firstName} ${u.lastName}${isMe(u.id, u.email) ? ' (You)' : ''}`,
          email: u.email,
          role: mappedRole[u.role],
          status: UserStatus.ACTIVE,
          isMyself: isMe(u.id, u.email)
        })
      })
    }
    setAllUsers(usersInTable)
  }, [users, invitedUsers, userData])

  return (
    <div className="protectedPageLayout">
      <PageTitle
        title="Users"
        buttonText={getPageButtonText(userData?.role, 'Add New User')}
        onButtonClick={() => { navigate('/users/create') }}
      />
      <DataTable columns={columns} data={allUsers} />
    </div>
  )
}
